import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import DashboardModal from '../DashboardModal';
import '../oneButton-css/DashboardSaveAiDesignsModal.css';

export type DashboardSaveAiDesignsModalProps = {
    open: boolean;
    theme: 'dark' | 'light';
    saving?: boolean;
    onCancel: () => void;
    onConfirm: (includeImages: boolean) => void;
};

export function DashboardSaveAiDesignsModal({
    open,
    theme,
    saving = false,
    onCancel,
    onConfirm,
}: DashboardSaveAiDesignsModalProps) {
    const [includeImages, setIncludeImages] = useState(true);

    useEffect(() => {
        if (open) {
            setIncludeImages(true);
        }
    }, [open]);

    return (
        <DashboardModal
            open={open}
            onClose={onCancel}
            title="Save AI designs?"
            theme={theme}
            width={480}
            centered
            maskClosable={!saving}
            destroyOnClose
            className="obd-save-ai-designs-modal"
            rootClassName={`obd-save-ai-designs-modal-root obd-theme-${theme}`}
            footer={
                <>
                    <Button onClick={onCancel} disabled={saving}>
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        onClick={() => onConfirm(includeImages)}
                        loading={saving}
                    >
                        {saving ? 'Saving…' : 'Confirm save'}
                    </Button>
                </>
            }
        >
            <div className="obd-save-ai-designs-modal__body">
                <label className="obd-save-ai-designs-modal__check">
                    <input
                        type="checkbox"
                        checked={includeImages}
                        disabled={saving}
                        onChange={(e) => setIncludeImages(e.target.checked)}
                    />
                    <span>Include all images when saving</span>
                </label>
                <p className="obd-save-ai-designs-modal__warning">
                    Un-checking this will only save images of the main 7 category cards.Category wise Tree cutting scenario,
                    More Options and More Layout Designs snapshots will not be saved.
                </p>
            </div>
        </DashboardModal>
    );
}
